import { useEffect, useState } from 'react';
import { installationProcessModel } from '../software-update/components/InstallationProcessModel';

const useInstallationProcess = () => {
  const [state, setState] = useState((window as any).installationStore.getState());

  useEffect(() => {
    (window as any).installationStore.subscribe((newState) => {
      setState(newState);
    });

    return () => {};
  }, []);

  return [state, installationProcessModel] as any;
};

export default useInstallationProcess;